<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h4.5Zm-.52-4.25a5.47 5.47 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5h5.98ZM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9ZM9.02 6c.05.52.17 1.03.36 1.5H3.75a.75.75 0 0 1 0-1.5h5.27Zm7.33-2.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Zm2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09Zm0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9ZM9.2 7c.1.35.24.68.4 1H3.5a.5.5 0 0 1-.09-1H9.2Zm7.15-3.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7Z"
    />
  </svg>
</template>
